/* eslint-disable compat/compat */
class PlpBackInStockFlow extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (this.els.showEmailTrigger) {
      this.listeners.add(
        this.els.showEmailTrigger.element,
        'click',
        this.onShowEmailTrigger.bind(this),
      )
    }

    this.listeners.add(this.els.emailForm.element, 'submit', e => {
      e.preventDefault()
      this.onFormSubmission()
    })

    document.addEventListener('variantChange', e => {
      this.hideRegisteredState()
      this.hideEmailForm()
    })

    document.addEventListener('BISModalClosed', e => {
      this.els.emailForm.element.ariaHidden = 'false'
      this.els.registeredMessage.element.ariaHidden = 'true'
    })
  }

  onShowEmailTrigger () {
    this.els.showEmailTrigger.element.ariaHidden = 'true'
    this.els.emailForm.element.ariaHidden = 'false'
  }

  hideEmailForm () {
    this.els.emailForm.element.ariaHidden = 'true'
  }

  showRegisteredState () {
    this.els.registeredMessage.element.ariaHidden = 'false'
  }

  hideRegisteredState () {
    this.els.registeredMessage.element.ariaHidden = 'true'
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const request = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
      {
        method: 'POST',
        headers: {
          revision: '2023-12-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    )

    if (!request.ok) {
      console.error(request)
    } else {
      this.hideEmailForm()
      this.showRegisteredState()
    }
  }

  async BISSubmission (variantId, productId, emailAddress, acceptMarketing) {
    window.BIS.create(emailAddress, variantId, productId, {
      accepts_marketing: acceptMarketing,
    }).then(resp => {
      if (resp.status === 'OK') {
        this.hideEmailForm()
        this.showRegisteredState()
      }
    })
  }

  onFormSubmission () {
    const variantId = Number(
      this.externalEls.modal?.element?.dataset?.variantId,
    )
    const productId = Number(
      this.externalEls.modal?.element?.dataset?.productId,
    )
    const emailAddress = this.els.emailInput?.element?.value
    const acceptMarketing = this.els.acceptMarketingCheckbox?.element?.checked

    if (!variantId || !productId || !emailAddress) return

    if (this.els.emailForm.element.dataset.backEndFlow === 'klaviyo') {
      this.KlaviyoSubmission(variantId, emailAddress)
      if (acceptMarketing) {
        this.newsletterSubscribe(emailAddress)
      }
    } else {
      this.BISSubmission(variantId, productId, emailAddress, acceptMarketing)
    }
    window.BAO.Utils.setCookie(`isRegistered-${variantId}`, variantId, 14)
    window.BAO.Utils.setCookie(`isRegistered`, true, 31)
  }

  async newsletterSubscribe (emailAddress) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: window.theme.klaviyo.mailingListId,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: '2023-12-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.hideEmailForm()
        this.showRegisteredState()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }
}

if (!customElements.get('plp-back-in-stock-flow')) {
  customElements.define('plp-back-in-stock-flow', PlpBackInStockFlow)
}
